import { FC } from 'react';
import cx from 'classnames';

import RichText from 'atoms/RichText';

import { TextBlock as TextBlockType } from 'lib/sanity/types';

export interface Props {
  block: TextBlockType;
  isLandingTab?: boolean;
  isCaseStudy?: boolean;
  index?: number;
}

const TextBlock: FC<Props> = ({ block, isLandingTab, isCaseStudy, index }) => {
  return (
    <div
      className={cx(
        'flex flex-col laptop:flex-row w-full tablet:px-content-narrow space-y-2 laptop:space-y-0',
        {
          'px-content-skinny': isLandingTab,
          'text-center': block.textAlign === 2,
        },
      )}
    >
      {isLandingTab && (
        <div
          className={cx(
            'text-med laptop:text-desktop-med text-gray-04 laptop:w-1/2 w-full font-book',
            {
              'laptop:opacity-0': index === 0,
            },
          )}
        >
          {block.header}
        </div>
      )}

      {(block.layout === null || block.layout === 1) && (
        <div
          key={block._key}
          className={cx('RichText RichText-small tablet:RichText-base w-full', {
            'laptop:px-3 w-full max-w-4xl': isLandingTab,
            'CaseStudy__inner-wrapper': isCaseStudy,
            'laptop:w-1/2': !isCaseStudy,
          })}
        >
          <RichText value={block.text} />
        </div>
      )}

      {block.layout === 2 && (
        <div
          key={block._key}
          className={cx(
            'flex w-full flex-col tablet:flex-row px-4 tablet:px-0',
            {},
          )}
        >
          <h3 className="text-med w-full tablet:w-1/2">{block.header}</h3>
          <div className="RichText RichText-small tablet:RichText-base w-full tablet:w-1/2">
            <RichText value={block.text} />
          </div>
        </div>
      )}

      {block.layout === 3 && (
        <div
          key={block._key}
          className={cx('w-full', {
            'laptop:px-3 w-full max-w-4xl': isLandingTab,
            'CaseStudy__inner-wrapper': isCaseStudy,
            'laptop:w-1/2': !isCaseStudy,
          })}
        >
          <h3 className="text-med pb-6">{block.header}</h3>
          <div className="RichText RichText-small tablet:RichText-base">
            <RichText value={block.text} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TextBlock;
